// extracted by mini-css-extract-plugin
module.exports = {"form":"auth_form__1-zN6"};